import React from 'react'

const NotFoundRoute = () => (
  <p style={{ display: 'flex', justifyContent: 'center' }}>
    404: Not found
  </p>
)

export default NotFoundRoute
